module.exports = __webpack_public_path__ + "static/media/so-apps.e16558d0.svg";